module.exports = __webpack_public_path__ + "img/wall.625f0a2f.svg";